import { render } from "./AnalysisDeliveryMessagePage.vue?vue&type=template&id=b0b55d78&scoped=true"
import script from "./AnalysisDeliveryMessagePage.vue?vue&type=script&lang=js"
export * from "./AnalysisDeliveryMessagePage.vue?vue&type=script&lang=js"

import "./AnalysisDeliveryMessagePage.vue?vue&type=style&index=0&id=b0b55d78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b55d78"]])

export default __exports__